const Index = () => import(/* webpackChunkName: "specialEventOrders" */ '@/components/orders/specialEventOrders')
export default {
    name: 'specialEventOrders',
    path: 'specialEventOrders',
    redirect: '/specialEventOrders/index',
    meta: {label: 'specialEventOrders'},
    component: {
        render (c) { return c('router-view') }
    },
    children: [
        {
            path: 'index',
            meta: {label: 'Index', auth: true},
            component: Index,
            props: true
        }
    ]
}
